import React from 'react'
import'./noDataFound.css'
import { MdNotInterested } from 'react-icons/md'

const NoDataFound = () => {
  return (
    <div className="noDataContainer">
        <div>
            <img src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-486.jpg" alt="" />
            {/* <MdNotInterested/> */}
            <h2>NO DATA FOUND</h2>
        </div>
    </div>

  )
}

export default NoDataFound